import { snakeCase } from 'lodash';
import { map } from 'rxjs/operators';
import { ApiService } from './../../../shared/services/api-service/api-service';
import { Injectable } from '@angular/core';

@Injectable()
export class NetworkStudentLevelDataService {
  constructor(public apiService: ApiService) {}

  public getNetworkStudentGroupData$(focus, filters) {
    return this.apiService
      .getStudentsGraphQL(this.getNetworkGroupDataPayload(focus, filters))
      .pipe(map(({ data: { NetworkStudentLevelGrouping } }) => NetworkStudentLevelGrouping));
  }

  private getNetworkGroupDataPayload(focus, formattedFilters) {
    const formattedFocus = focus.toLowerCase();
    const query = `
      query NetworkStudentLevel($filter: [NetworkDashStudentLevelFilter]!) {
        NetworkStudentLevelGrouping(focus:"${formattedFocus}", filters: $filter) {
          groupData {
            key
            human
            tooltip
            rowData {
              columnKey
              data
              meta
            }
          }
          columnData {
            graphQlKey,
            label,
            columnDataFormat
          }
        }
      }
    `;
    return { query, fetchPolicy: 'no-cache', variables: { filter: formattedFilters } };
  }
}
